import { createGenericDispatcher } from '../action-dispatcher-factory';

import { UserApiClient } from '../../api/user-api-client';

export const getSharedEmails = (username: string) =>
  createGenericDispatcher({
    name: 'SHARED_EMAILS',
    loadFunction: new UserApiClient(username).sharedApplicants,
    args: { username },
  });
